import { type Key } from "react";

export type InputChoiceInputProps<Value extends Key> = {
  value: Value;
  name?: string;
  active?: boolean;
  disabled?: boolean;
  "data-test"?: string;
};

/**
 * Visually hidden checkbox that mirrors the choice's selected state — kept so a
 * surrounding `<form>` can read the value by `name`. Internal to `InputChoice`;
 * not part of the block's public surface.
 */
export function InputChoiceInput<Value extends Key>({
  name,
  value,
  active,
  disabled,
  "data-test": dataTest = "input-choice-input",
}: InputChoiceInputProps<Value>) {
  return (
    <input
      data-slot="input-choice-input"
      data-test={dataTest}
      className="pointer-events-none absolute opacity-0"
      readOnly
      name={name}
      value={String(value)}
      type="checkbox"
      checked={active}
      disabled={disabled}
      data-checked={active}
    />
  );
}
